import { computed, inject } from '@angular/core';
import { ApiService } from '@libs/core/base-config';
import { AsyncState, asResult, computedFailure, initialState, loadingState } from '@libs/core/lib/state/async-states';
import {
  createPaymentIntent,
  exchangeRate,
  paymentIntentConfirm,
} from '@libs/mtjr/shared/generated/entities/payment-intent/service/payment-intent.service';
import { Dtos } from '@libs/mtjr/shared/generated/types';
import { patchState, signalStoreFeature, withComputed, withMethods, withState } from '@ngrx/signals';

export function withPaymentIntentConfirm() {
  return signalStoreFeature(
    withState<{ paymentIntentConfirmState: AsyncState<void> }>({
      paymentIntentConfirmState: initialState(),
    }),

    withMethods((store, apiService = inject(ApiService)) => ({
      async paymentIntentConfirm(paymentIntentConfirmBody: Dtos.PaymentIntentConfirmBody) {
        patchState(store, { paymentIntentConfirmState: loadingState() });
        const result = await asResult(paymentIntentConfirm(apiService, paymentIntentConfirmBody));
        patchState(store, { paymentIntentConfirmState: result });
      },
    })),
    withComputed((store) => ({
      paymentIntentConfirmLoading: computed(() => store.paymentIntentConfirmState().type === 'loading'),
      paymentIntentConfirmFailure: computedFailure(store.paymentIntentConfirmState),
    })),
  );
}

export function withCreatePaymentIntent() {
  return signalStoreFeature(
    withState<{ createPaymentIntentState: AsyncState<Dtos.PaymentIntentResponse> }>({
      createPaymentIntentState: initialState(),
    }),

    withMethods((store, apiService = inject(ApiService)) => ({
      async createPaymentIntent(createPaymentIntentBody: Dtos.CreatePaymentIntentBody) {
        patchState(store, { createPaymentIntentState: loadingState() });
        const result = await asResult(createPaymentIntent(apiService, createPaymentIntentBody));
        patchState(store, { createPaymentIntentState: result });
      },
    })),
    withComputed((store) => ({
      createPaymentIntentLoading: computed(() => store.createPaymentIntentState().type === 'loading'),
      createPaymentIntentFailure: computedFailure(store.createPaymentIntentState),
    })),
  );
}

export function withExchangeRate() {
  return signalStoreFeature(
    withState<{ exchangeRateState: AsyncState<Dtos.ExchangeRateResponse> }>({
      exchangeRateState: initialState(),
    }),

    withMethods((store, apiService = inject(ApiService)) => ({
      async exchangeRate() {
        patchState(store, { exchangeRateState: loadingState() });
        const result = await asResult(exchangeRate(apiService));
        patchState(store, { exchangeRateState: result });
      },
    })),
    withComputed((store) => ({
      exchangeRateLoading: computed(() => store.exchangeRateState().type === 'loading'),
      exchangeRateFailure: computedFailure(store.exchangeRateState),
    })),
  );
}
